var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SET_USER } from './types';
import store from '../store';
export function setUser(user) {
    return {
        type: SET_USER,
        payload: user,
    };
}
const grabUser = (user) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        store.dispatch(setUser(user));
    }
    catch (err) {
        console.log('error grabUser');
    }
});
const removeUser = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        store.dispatch(setUser({}));
    }
    catch (err) {
        console.log('error removeUser');
    }
});
export { grabUser, removeUser };
